import $ from 'jquery';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '../scss/style.scss';

/*------------------------------------------
	common
------------------------------------------*/
// SP menu
(function($) {

  $(function() {
    $('.js-nav-btn').on('click',function() {
      $('.js-nav').fadeToggle();
      $(this).toggleClass('is-close');
    });
    $('.js-nav a[href^="#"]').on('click',function() {
      $('.js-nav').fadeOut();
      $('.js-nav-btn').removeClass('is-close');
    });

    // sub menu
    $('.js-nav-parent').on('click', function() {
      $('+ .js-nav-child', this).slideToggle();
      $(this).toggleClass('is-open');
    });
  });

  // SP CV
  $(function() {
    $('.js-cv02-open').on('click',function() {
      $('.js-cv02-content').fadeIn();
    });
    $('.js-cv02-close').on('click',function() {
      $('.js-cv02-content').fadeOut();
    });
    $('.js-cv03-open').on('click',function() {
      $('.js-cv03-content').fadeIn();
    });
    $('.js-cv03-close').on('click',function() {
      $('.js-cv03-content').fadeOut();
    });
  });

  // PC reserve
  $(function() {
    $('.js-reserve02-open').on('click',function() {
      $('.js-reserve02').fadeIn();
    });
    $('.js-reserve02-close, .js-reserve02-overlay').on('click',function() {
      $('.js-reserve02').fadeOut();
    });
    $('.js-reserve03-open').on('click',function() {
      $('.js-reserve03').fadeIn();
    });
    $('.js-reserve03-close, .js-reserve03-overlay').on('click',function() {
      $('.js-reserve03').fadeOut();
    });
  });

  // SP reserve
  $(function() {
    $('.js-reserve01-open').on('click',function() {
      $('.js-reserve01').fadeIn();
    });
    $('.js-reserve01-close, .js-reserve01-overlay').on('click',function() {
      $('.js-reserve01').fadeOut();
    });
  });

  // Doctor calendar modal
  $(function() {
    var $modal = $('.js-doctor-calendar');
    if (!$modal.length) {
      return;
    }

    var openModal = function() {
      $modal.fadeIn(200);
      $('body').css('overflow', 'hidden');
    };
    var closeModal = function() {
      $modal.fadeOut(200);
      $('body').css('overflow', '');
    };

    $('.js-doctor-calendar-open').on('click', openModal);
    $('.js-doctor-calendar-close, .js-doctor-calendar-overlay').on('click', closeModal);
    $(document).on('keydown.doctorCalendar', function(e) {
      if (e.key === 'Escape' && $modal.is(':visible')) {
        closeModal();
      }
    });
  });


  /*------------------------------------------
    home
  ------------------------------------------*/
  document.addEventListener( 'DOMContentLoaded', function() {

    // js-home-mv-slider
    if(document.getElementsByClassName('js-home-mv-slider').length) {
      var jsHomeMvSlider_option	=	{
            type					:	'fade',
            rewind				:	true,
            speed					:	3000,
            arrows				:	false,
            pagination		: false,
            autoplay			:	true,
            pauseOnHover	:	false,
            pauseOnFocus	:	false,
          },
          jsHomeMvSlider = new Splide( '.js-home-mv-slider', jsHomeMvSlider_option );
      jsHomeMvSlider.mount();
    }

    if(document.getElementsByClassName('js-home-department-slider').length) {
      var jsHomeDepartmentSlider_option	=	{
            type					:	'fade',
            rewind				:	true,
            speed					:	3000,
            arrows				:	false,
            pagination		: false,
            autoplay			:	true,
            pauseOnHover	:	false,
            pauseOnFocus	:	false,
          },
          jsHomeDepartmentSlider = new Splide( '.js-home-department-slider', jsHomeDepartmentSlider_option );

      // ナビゲーション、カウンター、ページャー要素の取得
      const navItems = document.querySelectorAll('.homeDepartment-nav__item');
      const totalCounter = document.querySelector('.homeDepartment-control-counter__total');
      const currentCounter = document.querySelector('.homeDepartment-control-counter__current');
      const prevButton = document.querySelector('.homeDepartment-control-pager__item.is-prev');
      const nextButton = document.querySelector('.homeDepartment-control-pager__item.is-next');

      // スライダーイベントのリスニング (スライド切り替え時)
      jsHomeDepartmentSlider.on('mounted move', () => {
          if (jsHomeDepartmentSlider.index === 0 && totalCounter) {
              totalCounter.textContent = jsHomeDepartmentSlider.length;
          }

          const currentIndex = jsHomeDepartmentSlider.index;

          // ナビゲーションのis-active切り替え
          navItems.forEach((item, index) => {
              if (index === currentIndex) {
                  item.classList.add('is-active');
              } else {
                  item.classList.remove('is-active');
              }
          });

          // カウンターの更新
          if (currentCounter) {
              currentCounter.textContent = currentIndex + 1;
          }
      });

      // homeDepartment-nav のホバーイベント
      navItems.forEach((item, index) => {
          // ホバーイベントを設定
          item.addEventListener('mouseenter', () => {
              // 目的のスライドに移動
              jsHomeDepartmentSlider.go(index);
          });
          // タッチデバイスでの予期せぬ動作を避けるため、クリックでも移動するように設定
          item.addEventListener('click', () => {
              jsHomeDepartmentSlider.go(index);
          });
      });

      if (prevButton) {
          prevButton.addEventListener('click', () => {
              jsHomeDepartmentSlider.go('<'); // 前のスライドへ
          });
      }
      if (nextButton) {
          nextButton.addEventListener('click', () => {
              jsHomeDepartmentSlider.go('>'); // 次のスライドへ
          });
      }
      jsHomeDepartmentSlider.mount();
    }

    // js-home-clinic-slider
    if(document.getElementsByClassName('js-home-clinic-slider').length) {
      var jsHomeClinicSlider_option	=	{
            type					:	'loop',
            gap						:	'20px',
            fixedWidth		:	'380px',
            arrows				:	false,
            pagination		: false,
            autoScroll: {
              speed					:	.7,
              pauseOnHover	:	false,
            },
            breakpoints		:	{
              767	: {
                gap						:	'16px',
                fixedWidth		:	'304px',
                autoScroll: {
                  speed					:	.5,
                },
              },
            },
          },
          jsHomeClinicSlider = new Splide( '.js-home-clinic-slider', jsHomeClinicSlider_option );
          jsHomeClinicSlider.mount({ AutoScroll });
    }

    // homeMessage 動画（クリックトグル・同時再生なし・再生オーバーレイ）
    const homeMessageMovieList = document.querySelector('.js-home-message-movieList');
    if (homeMessageMovieList) {
      const CONTROL_BAND_PX = 56;
      const videos = homeMessageMovieList.querySelectorAll('video');

      videos.forEach((video) => {
        const item = video.closest('.homeMessage-movieList__item');
        const playBtn = item && item.querySelector('.js-home-message-playBtn');

        video.addEventListener('play', () => {
          if (item) item.classList.add('is-playing');
          videos.forEach((v) => {
            if (v !== video) v.pause();
          });
        });
        video.addEventListener('pause', () => {
          if (item) item.classList.remove('is-playing');
        });

        video.addEventListener('click', (e) => {
          const rect = video.getBoundingClientRect();
          const relY = e.clientY - rect.top;
          if (relY > rect.height - CONTROL_BAND_PX) return;
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            videos.forEach((v) => {
              if (v !== video) v.pause();
            });
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!video.paused) return;
            videos.forEach((v) => {
              if (v !== video) v.pause();
            });
            video.play().catch(() => {});
          });
        }
      });
    }

  });

})(jQuery);
